var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceProviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 125,
    viewBox: "0 0 194 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.001,
    y: 43.8389,
    width: 45.8301,
    height: 45.8301,
    rx: 5.69504,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.580128
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.3359,
    y: 87.6387,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.626,
    y: 87.9287,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.164,
    y: 74.2949,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.454,
    y: 74.585,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.609,
    y: 52.8301,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.899,
    y: 53.1201,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.6875,
    y: 69.0742,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9776,
    y: 69.3643,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 33.6855,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.29006,
    y: 33.9756,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.6719,
    y: 13.3809,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9619,
    y: 13.6709,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.2422,
    y: 7,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5323,
    y: 7.29006,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_15726_161113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.828,
    y: 27.8848,
    width: 35.3878,
    height: 35.3878,
    rx: 9.91694,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.118,
    y: 28.1748,
    width: 34.8077,
    height: 34.8077,
    rx: 9.62687,
    stroke: "black",
    strokeWidth: 0.580128
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.375 66.689C95.3078 66.689 97.1178 69.4711 97.0172 83.1131H97.3189C97.3189 69.4711 99.0954 66.689 105.028 66.689V66.4209C99.0954 66.4209 97.3189 63.5718 97.3189 49.9297H97.0172C97.1178 63.5718 95.3078 66.4209 89.375 66.4209V66.689Z",
    fill: "#2475FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15726_161113",
    x: 66.1757,
    y: 86.4784,
    width: 37.7111,
    height: 37.7092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.580128,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_15726_161113",
    x: 111.424,
    y: 72.5545,
    width: 38.8714,
    height: 38.8694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.870192,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_15726_161113",
    x: 146.808,
    y: 47.0288,
    width: 46.9932,
    height: 46.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.90064,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_15726_161113",
    x: 27.8862,
    y: 63.2729,
    width: 46.9932,
    height: 46.9912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.90064,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_15726_161113",
    x: 0.264542,
    y: 26.9501,
    width: 48.8615,
    height: 48.8596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.36773,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_15726_161113",
    x: 49.9315,
    y: 11.6405,
    width: 38.8714,
    height: 38.8694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.870192,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_15726_161113",
    x: 92.5067,
    y: 0.264542,
    width: 48.8615,
    height: 48.8596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.36773,
    result: "effect1_foregroundBlur_15726_161113"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_15726_161113",
    x: 122.093,
    y: 21.1493,
    width: 48.8615,
    height: 48.8596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.36773,
    result: "effect1_foregroundBlur_15726_161113"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceProviders);
export default __webpack_public_path__ + "static/media/service-providers.7e8c8ad6a7cba1775d60adf881609078.svg";
export { ForwardRef as ReactComponent };